import React from "react";
import BellIcon from "../../components/Icons/BellIcon";
import { Divider } from "@mui/material";
import TextButton from "../../../application/components/Button/TextButton";
import BtnPrimary from "../../../application/components/Button/BtnPrimary";
import { dividerStyle } from "../../components/Dashboard/Tables/Styles";


function NotificationPage() {


  return (
    <div className=" h-screen flex justify-between flex-col bg-white">
      <div>
        <div className="flex gap-4 p-6 ">
          <BellIcon />
          <div className="fle flex-col  gap-2">
            <p className="font-bold mb-2 text-[14px] text-[#292727] font-sans not-italic leading-6">Employee bio update!</p>
            <p className="font-normal text-[12px] text-[#292727] font-sans not-italic leading-normal">John Doe recently updated their profile information</p>
          </div>
        </div>
        <Divider sx={dividerStyle} />
        <div className="flex gap-4 p-6">
          <BellIcon fill="#98A2B3" />
          <div className="fle flex-col gap-2">
            <p className="font-bold mb-2 text-[14px] text-[#98A2B3] font-sans not-italic leading-6">Today is Wade Warren's birthday</p>
            <p className="font-normal text-[12px] text-[#292727] font-sans not-italic leading-normal">John Doe recently updated their profile information</p>
          </div>
        </div>
        <Divider sx={dividerStyle} />
        <div className="flex gap-4 p-6">
          <BellIcon fill="#98A2B3" />
          <div className="fle flex-col gap-2">
            <p className="font-bold mb-2 text-[14px] text-[#98A2B3] font-sans not-italic leading-6">Today is Wade Warren's birthday</p>
            <p className="font-normal text-[12px] text-[#292727] font-sans not-italic leading-normal">John Doe recently updated their profile information</p>
          </div>
        </div>
        <Divider sx={dividerStyle}  />
      </div>
      <div className="flex gap-2 justify-end p-6 ">
        <TextButton color='#292727' text="Clear all" />
        <BtnPrimary text="Mark all as read" /> 
      </div>
    </div>
  );
}

export default NotificationPage;
